import moment from 'moment';

export default function timeUntilEvent(startTime, currentTime) {
  const timeDiff = moment(startTime).diff(moment(currentTime));

  return moment.duration(timeDiff).humanize();
}
